module.exports = __webpack_public_path__ + "img/doorway_black.98b47768.svg";